import { Flex, Skeleton } from 'antd';
import { useGetClient } from 'api/clients/use-get-client.ts';
import { useGetManyExpensesByEntity } from 'api/expenses/use-get-many-expenses-by-entity.ts';
import { ExpenseCreate } from 'components/expenses/expense-create';
import type { IExpenseFormFields } from 'components/expenses/expense-form';
import { ExpensesList } from 'components/expenses/expenses-list';
import type { IExpensesListWithCreateButtonProps } from './types';

export const ExpensesListWithCreateButton = (props: IExpensesListWithCreateButtonProps) => {
  const { orderId, tripId, whTaskId, clientId } = props;

  const {
    data: expenses,
    isLoading,
    isPreviousData,
  } = useGetManyExpensesByEntity({ page: 1, limit: 50, orderId, tripId, whTaskId, clientId });
  const { data: client, isFetching: isFetchingClient } = useGetClient(clientId);

  const initialValues: Partial<IExpenseFormFields> | undefined = client
    ? { partner: { value: client.id, label: client.shortName || client.name } }
    : undefined;

  return (
    <Flex gap='middle' vertical>
      <Skeleton loading={isLoading}>
        <Flex gap='small' align='center' justify='flex-end'>
          <ExpenseCreate
            orderId={orderId}
            tripId={tripId}
            whTaskId={whTaskId}
            initialValues={initialValues}
            isLoadingData={isFetchingClient}
            partnerDisabled={!!clientId}
          />
        </Flex>
        <ExpensesList expenses={expenses?.data || []} isLoading={isPreviousData} />
      </Skeleton>
    </Flex>
  );
};
